import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=b5410aba&scoped=true&"
import script from "./schedule.vue?vue&type=script&lang=js&"
export * from "./schedule.vue?vue&type=script&lang=js&"
import style0 from "./schedule.vue?vue&type=style&index=0&id=b5410aba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5410aba",
  null
  
)

export default component.exports